import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import Modal from 'react-modal'; // Import a modal component like react-modal
import { BASELINE } from "../../util";
import { toast } from "react-hot-toast";
import SettingModal from "./setting";
import { FaHome, FaLightbulb, FaBook, FaClock, FaSearch, FaCrown } from 'react-icons/fa';
import { LuCrown } from "react-icons/lu";
import { RiHomeFill } from "react-icons/ri";
import { GiPaperTray } from "react-icons/gi";
import { MdClass } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import PromotionModal from "../../Components/popmodal";
import { FiMenu } from 'react-icons/fi';

const SDM = ({ handleHomeworkClick, activeIndex, setActiveIndex, user, onLogout, testType, setdashboard, dashboard }) => {
    const navigate = useNavigate();
    const [couponCode, setCouponCode] = useState(""); // State for coupon code
    const [isCouponValid, setIsCouponValid] = useState(null); // State for validation status
    const [isVerifying, setIsVerifying] = useState(false); // State to show loading while verifying
    const [parentData, setParentData] = useState([]); // State to store parent data
    const [loading, setLoading] = useState(false); // State to handle loading
    const [isOpen2, setIsOpen2] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isHamburgerMenuOpen, setIsHamburgerMenuOpen] = useState(false);

    // 모바일 메뉴 항목 클릭 시 실행: 전달받은 액션 실행 후 메뉴 닫기
    const handleMobileMenuItemClick = (action) => {
        action(); // 전달된 함수를 실행하고
        setIsHamburgerMenuOpen(false); // 메뉴 닫기
    };
    const validCouponCodes = ['MMTFREE3MONTHS']; // Replace with actual coupon codes

    const handleSave = (updatedUser) => {
        // TODO: 서버로 업데이트 요청 등을 처리
    };

    const handleDashboardChange = async (index) => {
        try {
            if (index === 0) {
                await axios.post(`${BASELINE}setdashboard`, {
                    u_id: user.u_id,
                    dashboard: "0"
                });
                // 메모리상의 user.dashboard도 갱신해야 main_dashboard의 loadDashboard()가
                // 이전 코스로 다시 리다이렉트하지 않음
                if (user) user.dashboard = "0";
                navigate('/main');
                return;
            }

            setdashboard(index);
            setActiveIndex(index);
        } catch (error) {
            console.error("Error updating dashboard:", error);
        }
    };

    const handleVerifyCoupon = async () => {
        setIsVerifying(true); // Start verification loading

        // Simulate an API call to verify the coupon code
        setTimeout(() => {
            if (validCouponCodes.includes(couponCode)) {
                setIsCouponValid(true); // Coupon is valid
                handlePremiumActivation(); // Call function to send the data to the server
            } else {
                setIsCouponValid(false); // Coupon is invalid
            }
            setIsVerifying(false); // End verification loading
        }, 1000); // Simulated delay
    };

    const handlePremiumActivation = () => {
        const today = new Date();
        const startPremiumDate = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD

        const endPremiumDate = new Date();
        endPremiumDate.setMonth(endPremiumDate.getMonth() + 3); // Add 3 months
        const endPremiumDateString = endPremiumDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD

        const premiumData = {
            u_id: user.u_id,
            start_date: startPremiumDate,
            end_date: endPremiumDateString
        };

        // Send the premium data to your API
        axios.post(BASELINE + 'premium/activate', premiumData)
            .then(response => {
                alert("Premium service activated!");
                window.location.reload(); // Refresh the website
            })
            .catch(error => {
                console.error(error);
                alert("Error activating premium service.");
            });
    };

    // Function to fetch pending parents data
    const fetchPendingParents = async () => {
        setLoading(true); // Set loading to true while fetching
        try {
            const response = await axios.post(BASELINE + "check/pending", { uid: user.u_id });
            setParentData(response.data); // Update state with the response data
        } catch (error) {
            console.error("Error fetching parents data:", error);
        }
        setLoading(false); // Stop loading after the fetch
    };

    // Handle approval logic
    const handleApprove = async (parentUId) => {
        try {

            // Send the approve request
            await axios.post(BASELINE + "send/approve", {
                u_id: user.u_id,  // Student's u_id (assuming you have access to user object)
                p_id: parentUId,  // Parent's u_id
                status: 'approve' // Status is "approve"
            });

            // Update the parentData to remove the approved parent
            setParentData(prevData => prevData.filter(parent => parent.u_id !== parentUId));

            // Show success message if the request is successful
            toast.success('Parent approved successfully!');
        } catch (error) {
            console.error('Error approving parent:', error);
            toast.error('Failed to approve the parent. Please try again.');
        }
    };

    // Handle denial logic
    const handleDeny = async (parentUId) => {
        try {

            // Send the deny request
            await axios.post(BASELINE + "send/approve", {
                u_id: user.u_id,  // Student's u_id (assuming you have access to user object)
                p_id: parentUId,  // Parent's u_id
                status: 'deny'    // Status is "deny"
            });

            // Update the parentData to remove the denied parent
            setParentData(prevData => prevData.filter(parent => parent.u_id !== parentUId));

            // Show success message if the request is successful
            toast.success('Parent denied successfully!');
        } catch (error) {
            console.error('Error denying parent:', error);
            toast.error('Failed to deny the parent. Please try again.');
        }
    };

    const sectionUrl = {
        SAT: 'sat', ACT: 'act', NMSQT: 'nmsqt',
        PSAT89: 'sat89', APCALCAB: 'apcalcab', APCALCBC: 'apcalcbc',
    };

    const navTo = (tab) => {
        const url = sectionUrl[testType];
        if (url) navigate(`/main/${url}${tab !== 'main' ? `/${tab}` : ''}`);
    };

    const gohome = async () => {
        const map = { SAT: 1, ACT: 6, NMSQT: 10, PSAT89: 14, APCALCAB: 18, APCALCBC: 22 };
        handleDashboardChange(map[testType] ?? 1);
        navTo('main');
    };

    const goresult = async () => {
        const map = { SAT: 2, ACT: 8, NMSQT: 12, PSAT89: 16, APCALCAB: 20, APCALCBC: 24 };
        handleDashboardChange(map[testType] ?? 2);
        navTo('result');
    };

    const goexam = async () => {
        const map = { SAT: 3, ACT: 7, NMSQT: 11, PSAT89: 15, APCALCAB: 19, APCALCBC: 23 };
        handleDashboardChange(map[testType] ?? 3);
        navTo('practice');
    };

    const goresume = async () => {
        handleDashboardChange(5);
        navTo('resume');
    };

    const gocourses = () => {
        handleDashboardChange(102);
        navTo('courses');
    };

    const activeNav = (() => {
        if ([1, 6, 10, 14, 18, 22].includes(dashboard)) return 'main';
        if ([2, 8, 12, 16, 20, 24].includes(dashboard)) return 'result';
        if ([3, 7, 11, 15, 19, 23].includes(dashboard)) return 'practice';
        if (dashboard === 5) return 'resume';
        if (dashboard === 102) return 'courses';
        return null;
    })();

    const NavItem = ({ id, icon: Icon, label, onClick }) => {
        const isActive = activeNav === id;
        return (
            <a
                className={`relative group flex items-center gap-2 py-2 cursor-pointer transition-all duration-200 ${isActive ? 'text-sky-300' : 'text-slate-400 hover:text-white'}`}
                onClick={onClick}
            >
                <Icon className={`text-[15px] transition-colors duration-200 ${isActive ? 'text-sky-300' : 'text-slate-500 group-hover:text-white'}`} />
                <span className="text-[13px] font-semibold tracking-wide">{label}</span>
                {isActive && (
                    <span className="absolute -bottom-[13px] left-0 w-full h-[2px] rounded-full bg-sky-400" />
                )}
            </a>
        );
    };

    return (
        <nav className="relative border-b border-white/10" style={{ background: "#0f2444" }}>
            <SettingModal
                isOpen={isOpen2}
                onClose={() => setIsOpen2(false)}
                user={user}
                onSave={handleSave}
                onLogout={onLogout}
            />
            <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
                {/* 왼쪽: 로고/타이틀 */}
                <div
                    className="text-[15px] font-bold tracking-widest flex items-center space-x-2 cursor-pointer text-white/80 hover:text-white transition-colors"
                    onClick={() => handleDashboardChange(0)}
                >
                    {dashboard !== 0 ? (
                        <>
                            {testType === "SAT" && <span>P-VAULT <span className="text-blue-600">SAT</span></span>}
                            {testType === "ACT" && <span>P-VAULT <span className="text-blue-600">ACT</span></span>}
                            {testType === "NMSQT" && <span>P-VAULT <span className="text-blue-600">NMSQT</span></span>}
                            {testType === "PSAT89" && <span>P-VAULT <span className="text-blue-600">SAT 8&9</span></span>}
                            {testType === "APCALCAB" && <span>P-VAULT <span className="text-blue-600">AP Calc AB</span></span>}
                            {testType === "APCALCBC" && <span>P-VAULT <span className="text-blue-600">AP Calc BC</span></span>}
                        </>
                    ) : (
                        <span>P-VAULT</span>
                    )}
                </div>

                {/* 가운데: 데스크탑 메뉴 */}
                {dashboard !== 0 && (
                    <div className="hidden md:flex items-center space-x-8">
                        <NavItem id="main"     icon={RiHomeFill}  label="Main"     onClick={gohome} />
                        <NavItem id="result"   icon={GiPaperTray} label="Result"   onClick={goresult} />
                        <NavItem id="practice" icon={FaBook}      label="Practice" onClick={goexam} />
                        <NavItem id="resume"   icon={FaClock}     label="Resume"   onClick={goresume} />
                        <NavItem id="courses"  icon={MdClass}     label="Courses"  onClick={gocourses} />
                    </div>
                )}

                {/* 오른쪽 */}
                <div className="flex items-center gap-3">
                    {user?.premium === 1 ? (
                        <button className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold text-yellow-300 border border-yellow-400/30 bg-yellow-400/10">
                            <LuCrown className="text-yellow-300" />
                            Premium
                        </button>
                    ) : (
                        <button
                            onClick={() => setModalOpen(true)}
                            className="flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold text-sky-300 border border-sky-400/30 bg-sky-400/10 hover:bg-sky-400/20 transition-all"
                        >
                            <LuCrown />
                            Upgrade
                        </button>
                    )}

                    <button
                        onClick={() => setIsOpen2(true)}
                        className="text-white/40 hover:text-white text-[18px] transition-colors hidden md:block"
                    >
                        <IoSettingsOutline />
                    </button>

                    <div className="md:hidden">
                        {dashboard !== 0 && (
                            <button onClick={() => setIsHamburgerMenuOpen(!isHamburgerMenuOpen)}>
                                <FiMenu className="text-[22px] text-white/60" />
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <div className="absolute bottom-0 left-0 w-full h-px bg-white/10" />

            {/* 모바일 햄버거 메뉴 */}
            <div
                className={`md:hidden fixed inset-0 z-50 transform transition-all duration-300 ease-in-out ${isHamburgerMenuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
            >
                {/* 배경 오버레이 */}
                <div
                    className={`absolute inset-0 bg-slate-900/30 backdrop-blur-sm transition-opacity duration-300 ${isHamburgerMenuOpen ? "opacity-100" : "opacity-0"}`}
                    onClick={() => setIsHamburgerMenuOpen(false)}
                />

                {/* 메뉴 컨테이너 */}
                <div
                    className={`relative h-full w-full flex flex-col bg-white transform transition-transform duration-300 ease-out ${isHamburgerMenuOpen ? "translate-x-0" : "-translate-x-full"}`}
                >
                    {/* 닫기 버튼 */}
                    <button
                        onClick={() => setIsHamburgerMenuOpen(false)}
                        className={`absolute top-4 right-4 p-2 text-slate-500 hover:text-blue-600 transition-all duration-300 ${isHamburgerMenuOpen ? "opacity-100 scale-100" : "opacity-0 scale-90"}`}
                    >
                        <FaTimes className="text-2xl" />
                    </button>

                    {/* 상단 사용자 정보 */}
                    <div className="p-6 pt-16 border-b border-slate-200">
                        <div className="flex items-center space-x-4">
                            <div className={`w-12 h-12 rounded-full bg-gradient-to-tr from-blue-500 to-blue-600 flex items-center justify-center transition-all duration-500 delay-100 transform ${isHamburgerMenuOpen ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}`}>
                                <span className="text-white text-lg font-bold">
                                    {user?.first_name?.charAt(0) || 'G'}
                                </span>
                            </div>
                            <div className={`transition-all duration-500 delay-150 transform ${isHamburgerMenuOpen ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}`}>
                                <div className="text-lg font-medium text-slate-800">{user?.first_name || 'Guest'}</div>
                                <div className="text-sm text-slate-500">{user?.email || 'guest@example.com'}</div>
                            </div>
                        </div>
                    </div>

                    {/* 메뉴 아이템 */}
                    <div className="flex-1 py-6">
                        <div className="max-w-md mx-auto space-y-1">
                            {[
                                { label: "Main",     icon: RiHomeFill,  action: gohome },
                                { label: "Result",   icon: GiPaperTray, action: goresult },
                                { label: "Practice", icon: FaBook,      action: goexam },
                                { label: "Resume",   icon: FaClock,     action: goresume },
                                { label: "Course",   icon: MdClass,     action: gocourses },
                            ].map(({ label, icon: Icon, action }, i) => (
                                <a
                                    key={label}
                                    onClick={() => handleMobileMenuItemClick(action)}
                                    className={`flex items-center px-6 py-4 space-x-4 text-slate-700 hover:bg-blue-50 hover:text-blue-600 rounded-xl transition-all duration-300 transform ${isHamburgerMenuOpen ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}
                                    style={{ transitionDelay: `${(i + 1) * 50}ms` }}
                                >
                                    <Icon className="text-2xl text-blue-500" />
                                    <span className="text-lg font-medium">{label}</span>
                                </a>
                            ))}

                            <a
                                onClick={() => { setIsHamburgerMenuOpen(false); setIsOpen2(true); }}
                                className={`flex items-center px-6 py-4 space-x-4 text-slate-700 hover:bg-blue-50 hover:text-blue-600 rounded-xl transition-all duration-300 transform ${isHamburgerMenuOpen ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}
                                style={{ transitionDelay: "300ms" }}
                            >
                                <IoSettingsOutline className="text-2xl text-blue-500" />
                                <span className="text-lg font-medium">Settings</span>
                            </a>
                        </div>
                    </div>

                    {/* 하단 정보 */}
                    <div className={`p-6 border-t border-slate-200 transition-all duration-300 delay-400 transform ${isHamburgerMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
                        <div className="max-w-md mx-auto flex items-center justify-between text-sm text-slate-400">
                            <span>Version 2.0.1</span>
                            <span>© 2024 Pvault</span>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default SDM;
